module.exports = {"id":"dp4_2l1q4","text":"Protecting personal data and privacy","instructions":"Individuals have legal rights regarding how their personal data is handled.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":false,"options":[{"id":"dp4_2l1q4-a1","text":"True","score":1.8},{"id":"dp4_2l1q4-a2","text":"Not sure","score":0},{"id":"dp4_2l1q4-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l1q4.json
// module id = 1226
// module chunks = 41